<template>
  <div class="the-navbar__user-meta flex items-center" v-if="activeUserInfo.displayName">

    <div class="text-right leading-tight hidden sm:block">
      <p class="font-semibold">{{ activeUserInfo.name}} {{ activeUserInfo.last_name}}</p>
    </div>

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">

      <div class="con-img ml-3">
        <img v-if="activeUserInfo.image" key="onlineImg" :src="activeUserInfo.image" alt="user-img" width="40" height="40" class="rounded-full shadow-md cursor-pointer block" />
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 9rem">
          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="$router.push('/settings').catch(() => {})">
            <feather-icon icon="SettingsIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Settings</span>
          </li>

          <vs-divider class="m-1" />

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="logout">
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Logout</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
import { getMessaging, deleteToken, getToken } from "firebase/messaging";

export default {
  data() {
    return {

    }
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser
    }
  },
  methods: {
    logout() {
      // If JWT login
      this.$store.dispatch('auth/logout')
        .then(() => { 
          // console.log("success")
        })
        .catch(error => {
          // console.log(error)
        })

      // const messaging = getMessaging();
      // getToken(messaging, { vapidKey: 'BIbx8lvCeFTxkgQVE7PnV7OuoZAmo7MDAiF3fV2mrX2nknET-xyGYf60iOEaDJP4ZwetGX26bKumRv6yE2j1w4M' }).then((currentToken) => {
      //     if (currentToken) {
            
      //     } else {
      //       // Show permission request UI
      //       console.log('No registration token available. Request permission to generate one.');
      //       // ...
      //     }
      //   }).catch((err) => {
      //     console.log('An error occurred while retrieving token. ', err);
      //     // ...
      //   });

      // deleteToken(messaging).then(() => {
      //   console.log('Token deleted.');
      //   // ...
      // }).catch((err) => {
      //   console.log('Unable to delete token. ', err);
      // });

      if(localStorage.getItem("accessToken")) {
        localStorage.removeItem("accessToken")
        this.$router.push('/login').catch(() => {})
      }

      localStorage.removeItem('clubData')
      localStorage.removeItem('userInfo')
      localStorage.removeItem('tokenExpiry')

      // This is just for demo Purpose. If user clicks on logout -> redirect
      this.$router.push('/login').catch(() => {})
    },
  }
}
</script>
